import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { AdminHeader } from "./adminShared";
import { Search, Loader2, Trash2 } from "lucide-react";

export default function AdminUsers() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); api.get(`/admin/users?search=${search}`).then(({ data }) => setRows(data.users)).finally(() => setLoading(false)); };
  useEffect(load, [search]);
  const toggle = async (id) => { try { await api.post(`/admin/users/${id}/toggle`); toast.success("Updated"); load(); } catch { toast.error("Failed"); } };
  const del = async (u) => {
    if (!window.confirm(`Delete this user permanently?\n\n${u.name} (${u.email})\n\nThis cannot be undone.`)) return;
    try { await api.delete(`/admin/users/${u.id}`); toast.success("User deleted"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not delete user"); }
  };
  return (
    <div>
      <AdminHeader title="Users / Runners" subtitle="Registered runners and their saved races." />
      <div className="relative max-w-sm mb-4"><Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" /><input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search users..." className="w-full border border-slate-300 rounded-lg pl-9 pr-3 py-2 text-sm outline-none focus:border-[#22d3ee]" data-testid="admin-users-search" /></div>
      <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto" data-testid="admin-users-table">
        {loading ? <div className="py-12 grid place-items-center"><Loader2 className="animate-spin text-[#22d3ee]" /></div> :
        <table className="w-full text-sm"><thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr><th className="text-left p-4">Name</th><th className="text-left p-4">Email</th><th className="text-left p-4">Role</th><th className="text-right p-4">Saved</th><th className="text-right p-4">Status</th><th className="text-right p-4">Actions</th></tr></thead>
          <tbody>{rows.map((u) => (
            <tr key={u.id} className="border-t border-slate-100" data-testid={`user-row-${u.id}`}>
              <td className="p-4 font-semibold text-slate-800">{u.name}</td>
              <td className="p-4 text-slate-600">{u.email}</td>
              <td className="p-4"><span className="text-xs bg-slate-100 px-2 py-0.5 rounded capitalize">{u.role}</span></td>
              <td className="p-4 text-right">{u.saved_count}</td>
              <td className="p-4 text-right">{u.disabled ? <span className="text-red-500 text-xs font-semibold">Disabled</span> : <span className="text-emerald-600 text-xs font-semibold">Active</span>}</td>
              <td className="p-4 text-right">
                {u.role !== "admin" && (
                  <div className="inline-flex items-center gap-1.5">
                    <button onClick={() => toggle(u.id)} className="text-xs font-semibold text-[#06b6d4] hover:underline px-2" data-testid={`toggle-user-${u.id}`}>{u.disabled ? "Enable" : "Disable"}</button>
                    <button onClick={() => del(u)} className="p-2 border border-slate-300 rounded-lg hover:bg-red-50 hover:text-red-500 inline-flex" title="Delete user permanently" data-testid={`delete-user-${u.id}`}><Trash2 size={15} /></button>
                  </div>
                )}
              </td>
            </tr>
          ))}</tbody>
        </table>}
        {!loading && rows.length === 0 && <p className="p-8 text-center text-slate-500">No users found.</p>}
      </div>
    </div>
  );
}
